import SC from "components/Stacker/constants/ShareConstants"

export const initialState = {
  isExpanded: false,
}

export default function shareReducer(previousState = initialState, action) {
  switch (action.type) {
    case SC.TOGGLE_SHARE:
      return { ...previousState, isExpanded: !previousState.isExpanded }
    default:
      return previousState
  }
}
